import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    // Poll until fbq is available (added by ob3_plugin or other source)
    const waitForFbq = () => {
      let pollInterval = setInterval(() => {
        if (typeof window.fbq === 'function') {
          clearInterval(pollInterval);
          // Create Meta Pixel click tracking script only after fbq is available
          const metaPixelClickTrackingScript = document.createElement('script');
          metaPixelClickTrackingScript.innerHTML = `
            function isToMainSite(a){
              try { 
                return new URL(a.href).hostname.endsWith('irelief.us'); 
              } catch(e){ 
                return false; 
              }
            }
            document.querySelectorAll('a,button').forEach(el=>{
              el.addEventListener('click', (e)=>{
                const a = e.currentTarget.tagName === 'A' ? e.currentTarget : e.currentTarget.closest('a');
                if (a && isToMainSite(a)) {
                  fbq('trackCustom', 'LanderCTAClick', {lander: location.hostname});
                }
              });
            });
          `;
          // Append the tracking script to the end of the body
          document.body.appendChild(metaPixelClickTrackingScript);
          // Store the script reference for cleanup
          window.metaPixelClickTrackingScript = metaPixelClickTrackingScript;
        }
      }, 50); // Check every 50ms
      // Store interval reference for cleanup
      return pollInterval;
    };
    const pollInterval = waitForFbq();
    // Cleanup function to remove scripts and intervals when component unmounts
    return () => {
      clearInterval(pollInterval);
      if (window.metaPixelClickTrackingScript && window.metaPixelClickTrackingScript.parentNode) {
        document.body.removeChild(window.metaPixelClickTrackingScript);
      }
    };
  }, []); // Empty dependency array ensures this runs once on mount
  return null; // This component doesn't render anything
}